var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileCrop = function SvgIconProfileCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 287,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.5 0H0v287h287V0H143.5Zm0 0C222.753 0 287 64.247 287 143.5S222.753 287 143.5 287 0 222.753 0 143.5 64.247 0 143.5 0Z",
    fill: "#F5F5F5",
    fillOpacity: 0.6
  })));
};
export default SvgIconProfileCrop;